/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_Q1Inputs */

const en_cad_faq_q1 = /** @type {(inputs: Cad_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is CADCraft really free?`)
};

/**
* | output |
* | --- |
* | "Is CADCraft really free?" |
*
* @param {Cad_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_q1 = /** @type {((inputs?: Cad_Faq_Q1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_Q1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_q1(inputs)
});
export { cad_faq_q1 as "cad.faq.q1" }